export class MarkMailAsTakeInChargeRequestParams {
  action: string;
  commentaires: string;
  dateEcheance: string;
  priseEnChargeExclusive: boolean;
  serviceDemandeId: number;
  servicePrincipalId: number;
  services: number[];
}
